import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import { AddAsectionsQuestionsResultLayer } from '../components/SECTION A/AddAsectionsQuestionsResultLayer'

export const AddAsectionsQuestionsResultPage = () => {
  return (
    <MasterLayout>
        <AddAsectionsQuestionsResultLayer />
    </MasterLayout>
  )
}
